import { Container, Grid, styled } from '@mui/material'
import {
  AccountBalanceOutlined as AccountBalanceOutlinedBase,
  CategoryOutlined as CategoryOutlinedBase,
  InboxOutlined as InboxOutlinedBase,
  ShoppingCartOutlined as ShoppingCartOutlinedBase
} from '@mui/icons-material'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.blue[50]}
  }
`
export const Strong = styled('strong')``

export const SegmentIcon = styled(AccountBalanceOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const FamilyIcon = styled(InboxOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const CategoryIcon = styled(CategoryOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const ProductIcon = styled(ShoppingCartOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`
